<template>
  <b-container fluid>
    <b-row>
     <b-col :lg="cols">
        <card>
          <TableActionHeader v-on:filterChange="onFilterChange" v-on:newItem="onNewItem"></TableActionHeader> 
          <MessagesTable :filter="filter" v-on:selectItem="onSelectItem" :messageType="messageType"></MessagesTable>
        </card>
      </b-col>
      <b-col>
         <InfoCard v-if="action == ''"></InfoCard>
        <card v-if="action == 'new'">
          <CardHeader :title="$t('item.new')" />
          <MessagesForm :item="item" :action="action" :messageType="messageType"></MessagesForm>
        </card>
         <card v-if="action == 'edit'">
          <CardHeader type="item" />
          <MessagesControl :item="item" :action="action"></MessagesControl>
        </card>
        <card v-if="action == 'edit'">
          <CardHeader type="item" />
          <MessagesForm :item="item" :action="action" :messageType="messageType"></MessagesForm>
        </card>
      </b-col>
     </b-row>
  </b-container>

</template>

<script>

import TableActionHeader from '@/components/Misc/TableActionHeader'
import CardHeader from '@/components/Misc/CardHeader'
import MessagesTable from '@/components/System/MessagesTable.vue'
import MessagesForm from '@/components/System/MessagesForm.vue'
import MessagesControl from '@/components/System/MessagesControl.vue'

export default {
    components: {
        MessagesTable, MessagesForm, TableActionHeader, CardHeader,
        MessagesControl
    },
    props: {
        messageType: {
          type: String,
          required: true,
          validator( value ) {
            return ['DRIVER','DRIVER_ANNOUNCEMENT'].includes(value)
          }
        }
    },
    data: function() {
        return {
            showForm: true,
            cols: 8,
            filter: null,
            timeout: 1000,
            item: {
                    "id": null,
                    "order": null,
                    "message": null
            },
            action: ""
        }
    },
    methods: {
        onFilterChange: function(filter) {
            this.filter = filter;
        },
        onNewItem: function() {
            this.item = {
                    "id": null,
                    "order": null,
                    "message": null
            };        
            this.action = "new";         
        },
        onSelectItem: function(item) { 
            this.item = item ? JSON.parse(JSON.stringify(item)) : {};
            this.action = item ? "edit" : "";
        },
        onClose(){
            this.action = "";
        }
    }
}
</script>
